import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { ScopeService } from '../services/scope/scope-service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SCOPES } from '../services/scope/scope-constants';

@Injectable({
  providedIn: 'root',
})
export class ScopeGuard implements CanActivate {
  private scopeService = inject(ScopeService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | boolean | UrlTree {
    const requiredScopeIds = route.data['scopeIds'] as number[];

    if (!requiredScopeIds || requiredScopeIds.length === 0) {
      return true;
    }

    let userScopes = this.scopeService.getUserScopes();

    if (userScopes.length === 0) {
      return this.scopeService.loadUserContext().pipe(
        map(() => {
          userScopes = this.scopeService.getUserScopes();
          return this.checkPermission(requiredScopeIds, userScopes);
        }),
        catchError(() => {
          return of(this.router.createUrlTree(['/login']));
        }),
      );
    }

    return this.checkPermission(requiredScopeIds, userScopes);
  }

  private checkPermission(requiredScopeIds: number[], userScopes: number[]): boolean | UrlTree {
    const hasPermission = this.scopeService.hasAnyScope(requiredScopeIds);

    if (hasPermission) {
      return true;
    }

    const isCustomer = userScopes.includes(SCOPES.PHARMACIES.CANCEL_REQUEST);

    if (isCustomer) {
      return this.router.createUrlTree(['/user']);
    } else {
      return this.router.createUrlTree(['/admin']);
    }
  }
}
